export default __webpack_public_path__ + "static/media/MinimumBuyValues.5493825f.png";